/**
 * 申请人类型
 */
export enum ANCS_TYPE {
    /**
     * 公司
     */
    COMPANY = 'Company',
    /**
     * 个人
     */
    PERSON = 'Person',
}
